module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p vertical-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3 style-404"
  }, [_c('br'), _vm._v(" "), _c('h1', [_vm._v("404")]), _vm._v(" "), _c('h1', [_vm._v("Página no encontrada.")]), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Lo sentimos, la página que buscas no existe o no se encuentra en nuestro servidor.")]), _vm._v(" "), _c('router-link', {
    staticClass: "home-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Volver al inicio. "), _c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4751e376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 337
// module chunks = 1